// extracted by mini-css-extract-plugin
export default {"collapsible":"Collapsible_collapsible__plJoN"};